export const DRIVEWAY_DCM_CLICK_TAG =
  'https://ad.doubleclick.net/ddm/trackclk/N7252.2990EDMUNDS.COMINC/B29471210.361465787;dc_trk_aid=553019926;dc_trk_cid=187422683;dc_lat=;dc_rdid=;tag_for_child_directed_treatment=;tfua=;ltd=?';
